<mat-form-field>
  <mat-label>{{ searchInputLabel }}</mat-label>
  <mat-chip-list #chipList [selectable]="selectable" [formControl]="selectionCtrl">
    <mat-chip
      disableRipple
      *ngIf="value"
      (removed)="remove()"
      [selectable]="selectable"
      [removable]="removable"
      [matTooltip]="value | functionDisplay: selectionDisplayWith"
    >
      <div class="selection-wrapper">
        <span class="selection-display">{{ value | functionDisplay: selectionDisplayWith }}</span>
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </div>
    </mat-chip>
    <input
      data-testid="search-input"
      *ngIf="!value"
      (blur)="clearSearch()"
      [formControl]="searchCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [placeholder]="searchInputPlaceholder"
    />
  </mat-chip-list>
  <mat-error>{{ error }}</mat-error>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="searchResultDisplayWith"
    (optionSelected)="onSelect($event.option.value)"
  >
    <mat-option
      *ngFor="let searchResult of searchResults$ | async; trackBy: searchResultTrackBy"
      [value]="searchResult"
    >
      {{ searchResult | functionDisplay: searchResultDisplayWith }}
    </mat-option>
    <mat-option disabled *ngIf="!(searchResults$ | async)?.length && searchCtrl.value">
      {{ searchInputEmptyMessage }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
